import React from 'react';

class UserSelection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allUsers: this.props.allUsers,
            linkedUsers: this.props.users,
            checklistId: this.props.checklistId,
            searchString: ""
        };

        this.onFieldChanged = this.onFieldChanged.bind(this);
        this.searchChanged = this.searchChanged.bind(this);
        this.compareUsers = this.compareUsers.bind(this);
    }

    onFieldChanged(e) {
        let dkey = e.target.getAttribute('data-key');
        let isChecked;
        if (e.target.checked == undefined) {
            isChecked =  dkey == "-1" ? !$('#hc-checklist-checkall').is(':checked') : !e.target.parentElement.firstChild.checked;
        }
        else
            isChecked = e.target.checked;
        this.props.saveLinkedUser(dkey, isChecked);
    }

    compareUsers(u1, u2) {
        let a = this.state.linkedUsers.find((u) => {return u.id == u1.id});
        let b = this.state.linkedUsers.find((u) => {return u.id == u2.id});
        if (a != undefined) {
            if (a.checked && b == undefined)
                return -1;
            if (!a.checked && b != undefined && b.checked)
                return 1;
        }
        else {
            if (b != undefined)
                return 1;
        }
        return 0;
    }

    getFilteredItems() {
        let items = this.state.allUsers;
        if (items === null || items === undefined) {
            items = [];
        }
        if (this.state.searchString) {
            var searchString = this.state.searchString.toLowerCase();
            return items.filter(function (o) {
                return o.name.toLowerCase().indexOf(searchString) >= 0;
            }.bind(this));
        }

        if (this.state.firstTime) {
            return items.sort(this.compareUsers);
            this.state.firstTime = false;
        }
        return items;
    }
    searchChanged(e) {
        this.state.searchString = e.target.value;
        this.setState({searchString: e.target.value});
    }

    render() {
        let divStyle = {verticalAlign:"middle", textAlign: "left", display:'flex', padding: "20px", paddingLeft: "5%"};
        divStyle['flexFlow'] = divStyle['WebkitFlexFlow'] = 'row';
        var checkBoxStyle = {};
        checkBoxStyle['flex'] = checkBoxStyle['WebkitFlex'] = '0 0 auto';

        let searchEnabled = true;
        let searchPanel;
        if (searchEnabled) {
            searchPanel = (<div className="hc-bb" style={{height: "60px", position:'relative'}}>
                <input className="hc-f4" ref="search" type="text" placeholder={HC_LANG.CHL_SEARCH}
                       value={this.state.searchString} onChange={this.searchChanged} spellCheck="false"
                       style={{position:'absolute', width:'95%', left:'1px', height:'100%', border:'none', outline:'none', paddingLeft:'2rem', paddingRight:'3rem'}}/>
                <i className="fa fa-search" onClick={function(){this.refs.search.focus()}.bind(this)} style={{position:'absolute', fontSize:'1.6rem', color:'#bfc7cd', cursor:"pointer", right:'1rem', top:'18px'}}/>
            </div>)
        };

        let allUsers = this.getFilteredItems();
        let allAssigned = (allUsers.length == this.props.users.length) & (this.props.users.find(function (u) {
            return u.checked == false;
        }) == undefined);

        let selectAllPanel = (
            <div className="hc-flex-display hc-bb" style={divStyle} onClick={this.onFieldChanged} data-key="-1">
                <input id="hc-checklist-checkall" className="big-checkbox"
                       data-key="-1"
                       checked= {allAssigned}
                       type="checkbox"
                       style={checkBoxStyle}/>
                <span className="hc-f3 hc-f-l" style={{marginLeft: "1rem", verticalAlign:"middle", cursor: "pointer"}} data-key="-1">{HC_LANG.ADM_ASSIGNED_ALLUSERS}</span>
            </div>
        );

        let listItems = [];
        if (allUsers != undefined)
            listItems = allUsers.map( (o) => {
                let checked = false;
                let user = this.props.users.find((u) => { return u.user_id == o.id});
                if (user != undefined)
                    checked = user.checked != undefined ? user.checked : true;
                return (
                    <div key={o.id} style={{margin:"auto", marginLeft:"5%", paddingTop: "2%",display: "flex"}}>
                        <input className="big-checkbox"
                               data-key={o.id}
                               checked={checked}
                               type="checkbox"
                               onChange={this.onFieldChanged}
                               style={checkBoxStyle}/>
                         <span className="hc-f3 hc-f-l" style={{marginLeft: "1rem", verticalAlign:"middle", cursor: "pointer", marginTop: "2.5px"}}
                               onClick={this.onFieldChanged}
                               data-key={o.id}>{o.name}</span>
                    </div>
                );
            });

        let userListStyle = {overflowY: "auto", width: "100%", position: "absolute", top: "130px", bottom: "10px"};
        return(
            (<div>
                {searchPanel}
                {selectAllPanel}
                <div style={userListStyle}>
                    {listItems}
                </div>
            </div>)
        )
    }
}

module.exports = UserSelection;


// WEBPACK FOOTER //
// ./checklists/userselection.js